var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget widget-metric"},[_c('h3',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('h4',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }